module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/logo-target-footer_66ed12f.png";